module.exports = __webpack_public_path__ + "img/huoban.25520915.png";